import React from 'react'
import jwt_decode from 'jwt-decode'
import { setAxiosErrorInterceptor,setAxiosJWTInterceptor,clearAxiosJWTInterceptor } from '_services/config'

type Auth = {
  'token':string | null
  'decoded':object
  'userID':string
  'name':string
  'img':string
  'permissions':string[]
  'hasPermission':(_:string) => boolean
  'hasPremium':boolean
  'isOnboarded':boolean
  'isAuthenticated':boolean
  'logout':(_:() => void) => void
}

const emptyAuth : Auth = {
  'token':null,
  'decoded':{},
  'permissions':[],
  'userID':'',
  'name':'',
  'img':'',
  'hasPermission':() => false,
  'hasPremium':false,
  'isOnboarded':false,
  'isAuthenticated':false,
  'logout':(f) => f()
}

export const ContextAuth = React.createContext<[Auth,(_:string) => void] | undefined>(undefined)

export const useAuthState = () : [Auth,(_:string) => void] => {
  const parseToken = () : Auth => {
    const jwt = localStorage.getItem('userToken')
    if(!!jwt)
    {
      const decoded = jwt_decode(jwt) as {
        ID:string
        permissions:string
        premium:string
        onboarded:string
        unique_name:string
        img:string
      }

      setAxiosJWTInterceptor(jwt)
      setAxiosErrorInterceptor(
        () => {
          localStorage.removeItem('userToken')
          setAuth(emptyAuth)
          clearAxiosJWTInterceptor()
        },
        () => {}
      )
      return {
        'token':jwt,
        'decoded':decoded,
        'permissions':decoded.permissions ? decoded.permissions.split(',') : [],
        'userID':decoded.ID,
        'name':decoded.unique_name,
        'img':decoded.img,
        'hasPermission':(x) => decoded.permissions.includes(x),
        'hasPremium':decoded.premium === 'true',
        'isOnboarded':decoded.onboarded === 'true',
        'isAuthenticated':true,
        'logout':(f) => {
          localStorage.removeItem('userToken')
          setAuth(emptyAuth)
          clearAxiosJWTInterceptor()
          f()
          window.location.reload()
        }
      }
    }
    else
    {
      return emptyAuth
    }
  }
  const [stateAuth,setAuth] = React.useState<Auth>(parseToken())
  return [
    stateAuth,
    (jwt:string) => {
      localStorage.setItem('userToken',jwt)
      setAuth(parseToken())
    },
  ]
}

export const useAuth = () : [Auth,(_:string) => void] => {
  const context = React.useContext(ContextAuth)
  if(!context)
  {
    throw new Error('useAuth - no provider')
  }
  return context
}

export default useAuth
